import { useRegisterSW } from "virtual:pwa-register/react";
import { useTranslation } from "react-i18next";
import "./update-prompt.css";

export function UpdatePrompt() {
  const { t } = useTranslation();
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisterError(err) {
      console.error("[pwa] service worker registration error:", err);
    },
  });

  if (!needRefresh) return null;

  return (
    <div className="update-prompt" role="status" aria-live="polite">
      <div className="update-prompt__inner">
        <p className="update-prompt__msg">{t("update.message")}</p>
        <div className="update-prompt__actions">
          <button
            type="button"
            className="btn btn-primary btn-sm"
            onClick={() => updateServiceWorker(true)}
          >
            {t("update.now")}
          </button>
          <button
            type="button"
            className="btn btn-secondary btn-sm"
            onClick={() => setNeedRefresh(false)}
          >
            {t("update.later")}
          </button>
        </div>
      </div>
    </div>
  );
}
